import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["tags", "imgType", "layoutType", "expirationDate"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { TagSpecial } from '@sbercloud/uikit-product-site-tag';
import { LAYOUT_TYPE } from '@sbercloud/uikit-product-utils';
import { PromoTag } from '@snack-uikit/promo-tag';
import { BannerCommon } from '../../helperComponents/BannerCommon';
import styles from "./styles.module.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var IMAGE_SIZE = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, LAYOUT_TYPE.Desktop, {
  rectangle: [396, 272],
  square: [272, 272]
}), LAYOUT_TYPE.DesktopSmall, {
  rectangle: [396, 272],
  square: [272, 272]
}), LAYOUT_TYPE.Tablet, {
  rectangle: [396, 272],
  square: [272, 272]
}), LAYOUT_TYPE.Mobile, {
  rectangle: [360, 247],
  square: [272, 272]
});
export function BannerPrimary(_ref) {
  var tags = _ref.tags,
    imgType = _ref.imgType,
    layoutType = _ref.layoutType,
    expirationDate = _ref.expirationDate,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(BannerCommon, _objectSpread({
    sizes: {
      image: IMAGE_SIZE[layoutType][imgType],
      mainGap: layoutType === 'mobile' ? 24 : 32
    },
    layoutType: layoutType,
    topSlot: (tags || expirationDate) && /*#__PURE__*/_jsxs("div", {
      className: styles.tags,
      children: [expirationDate && /*#__PURE__*/_jsx(PromoTag, {
        size: "xs",
        text: "\u0414\u0435\u0439\u0441\u0442\u0432\u0443\u0435\u0442 \u0434\u043E ".concat(expirationDate),
        appearance: "neutral",
        color: "decor"
      }), tags === null || tags === void 0 ? void 0 : tags.map(function (props, index) {
        return /*#__PURE__*/_jsx(TagSpecial, _objectSpread({}, props), index);
      })]
    })
  }, props));
}